import { ImportStatus } from '@keepeek/commons';
import Axios from 'axios';
import axiosRetry from 'axios-retry';
import Dropzone from 'dropzone';

var MAX_UPLOAD_RETRY = 20;
/**
 * Convert Dropzone upload status to Keepeek import status
 * @param dropzoneStatus Dropzone upload status
 * @returns Keepeek import status
 */
function convertStatus(dropzoneStatus, progress) {
    // Be optimistic, success status will be set when upload queue is empty
    if (dropzoneStatus === Dropzone.UPLOADING && progress && progress === 100) {
        return ImportStatus.SUCCESS;
    }
    switch (dropzoneStatus) {
        case Dropzone.ADDED:
        case Dropzone.QUEUED:
        case Dropzone.ACCEPTED:
            return ImportStatus.ADDED;
        case Dropzone.UPLOADING:
            return ImportStatus.UPLOADING;
        case Dropzone.CANCELED:
            return ImportStatus.CANCELED;
        case Dropzone.ERROR:
            return ImportStatus.ERROR;
        case Dropzone.SUCCESS:
            return ImportStatus.SUCCESS;
    }
    return ImportStatus.ERROR;
}
var createCustomUploadRetryAxiosInstance = function () {
    var instance = Axios.create();
    instance.interceptors.request.use(function (config) {
        if (!config.headers) {
            config.headers = {};
        }
        config.headers.Authorization = Axios.defaults.headers.common.Authorization;
        return config;
    });
    axiosRetry(instance, {
        retries: MAX_UPLOAD_RETRY,
        retryDelay: function (retryNumber, axiosError) {
            console.info("detect network error : let's retry request... [retryNumber=".concat(retryNumber, "/").concat(MAX_UPLOAD_RETRY, "] [URL=").concat(axiosError.config.url, "] [Method=").concat(axiosError.config.method, "]"), axiosError.toJSON());
            return axiosRetry.exponentialDelay(retryNumber) + 2000;
        },
        retryCondition: function (error) {
            var _a, _b, _c;
            // detect network connection issues
            var url = ((_a = error.config.url) === null || _a === void 0 ? void 0 : _a.startsWith("/")) ? error.config.url : "/".concat(error.config.url);
            return ((((_b = error.config.method) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "post" &&
                url.startsWith("/api/dam/files") &&
                // network cut
                (error.message === "Network Error" ||
                    // exchange with the API while the token is temporarily no longer valid
                    (((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 401 && error.response.data.message === "Unauthorized"))) ||
                false);
        }
    });
    return instance;
};

export { convertStatus, createCustomUploadRetryAxiosInstance };
//# sourceMappingURL=utils.js.map
